export default __webpack_public_path__ + "static/media/STier.9295d1b6.png";